<template>
  <div id="loginComponent">
    <div class="d-md-flex flex-column justify-center align-center flex-row">
      <v-container class=" px-10 px-md-0 py-0">
        <v-row>
          <v-col
            cols="12"
            dense
          >
            <h3
              v-if="tenant.company_display_name != null"
              class="whiteText pt-8"
            >
              login to {{ tenant.company_display_name }}'s <br> Candidate Portal
            </h3>
            <h2
              v-else
              class="whiteText pt-8"
            >
              Login to<br>Candidate Portal
            </h2>
          </v-col>
        </v-row>
        <v-form
          v-model="valid"
          class="d-flex justify-center"
        >
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="loginData.email"
                class="inputField mb-0"
                outlined
                dark
                :rules="Rules.email"
                label="Email"
                required
                autofocus
                :disabled="loading"
                :error-messages="errors"
                @input="errors = []"
                @keyup.enter="login"
              />
              <v-text-field
                v-model="loginData.password"
                class="inputField"
                outlined
                dark
                :rules="Rules.password"
                label="Password"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPassword ? 'text' : 'password'"
                required
                :disabled="loading"
                @click:append="showPassword = !showPassword"
                @input="errors = []"
                @keyup.enter="login"
              />
            </v-col>
          </v-row>
        </v-form>
        <v-row>
          <v-col
            cols="12"
            class="d-flex justify-center pt-0"
          >
            <div
              v-for="(error,index) in errorDescription"
              :key="index"
              class="red--text"
            >
              {{ index.toUpperCase() }}:
              <span
                v-for="(val, valIndex) in error"
                :key="valIndex"
              >{{ val }} </span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="d-flex justify-center pt-0"
          >
            <v-btn
              block
              tile
              :disabled="!valid"
              :loading="loading"
              @click="login"
            >
              Login
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            :sm="tenant.company_display_name != null ? 6 : 12"
            class="d-flex justify-end pt-0"
          >
            <v-btn
              block
              tile
              outlined
              class="whiteText"
              @click="forgotten"
            >
              Reset Password
            </v-btn>
          </v-col>
          <v-col
            v-if="tenant.company_display_name != null"
            cols="12"
            sm="6"
            class="d-flex justify-start pt-0"
          >
            <v-btn
              block
              tile
              outlined
              class="whiteText"
              @click="register"
            >
              Register
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LoginComponent',
  props: {
    tenant: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    valid: false,
    show: false,
    showPassword: false,
    errorDescription: '',
    loginData: {
      email: '',
      password: ''
    },
    loading: false,
    errors: []
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    login () {
      this.loading = true
      this.errors = []
      const url = this.URLs.core.auth.login
      this.$parent.logDetail = this.loginData
      axios.post(url, this.loginData).then(
        response => {
          if (!response.data.redirect) {
            this.$parent.showSelectAgency(response.data)
          } else {
            window.location.href = response.data.redirect
          }
        },
        error => {
          this.errors = error.response.data.message
          this.loading = false
          this.errorDescription = error.response.data.errors
          this.$emit('loginFailed', error)
        }
      )
    },
    forgotten () {
      this.$emit('forgotten')
    },
    register () {
      window.location.href = '/register?clear=true'
    }
  }
}
</script>
<style lang="scss">
@import './resources/sass/variables';
#loginComponent {
  .v-btn{
    font-size: x-small;
    @media screen and (min-width: 500px) {
      font-size: small;
    }
    @media screen and (min-width: 1400px) {
      font-size: medium;
    }
  }
  .error--text{
    color: $agencyColorDark !important
  }
  .whiteText{
    color: white;
     &.v-btn{
      font-size: x-small;
      @media screen and (min-width: 600px){
        font-size: small;
      }
      @media screen and (min-width: 1400px){
        font-size: initial;
      }
    }
  }
  .v-input__slot {
    background: $agencyColorLight;
  }
  .unskew{
    text-align: center;
    // transform: skewY(-10deg);
    color: white;
    min-height: 500px;
    @media screen and (min-width: 960px) {
      max-width: 65%;
      // transform: skewX(15deg);
      margin: 1rem 1rem;
      padding: 1rem 1rem;
    }
  }
}
</style>
